<span class="!mt-0 mobi-ui-text-block-label-major">{{ title }}</span>
<p class="">{{ text }}</p>
